document.addEventListener("turbo:load", function(){

  const element = document.querySelector("#existing-order-checker")
  if (element) {
    const options = {
      clearAfterSelect: true,
      maxOptions: null,
      onChange: function(value) {
        if (value) {
          var path = element.dataset.path
          $.get(path, {'buyer_order[buyer_id]':value}, null, 'script' );
        }
      }
    }
    const tom = new TomSelect(element, options)
    document.addEventListener("turbo:before-cache", () => { tom.destroy() } )
  }
});
